"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.boxConfig = void 0;
var react_1 = __importDefault(require("react"));
var GetCommonConfigByType_1 = require("@CommonFrontend/WidgetRegistry/Utils/GetCommonConfigByType");
var MakeConfig_1 = require("../Utils/MakeConfig");
var BoxWidget_1 = require("Project/QwilrEditor/Widgets/BoxWidget/BoxWidget");
var Deserialise_1 = require("Project/QwilrEditor/Tokenization/Deserialise");
var slate_1 = require("slate");
var Utils_1 = require("Project/QwilrEditor/Utils");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var FeatureFlag_1 = __importDefault(require("@CommonFrontendBackend/FeatureFlag"));
var TelemetryParameterValue_1 = require("@CommonFrontend/Telemetry/TelemetryParameterValue");
var Paragraph_1 = require("./Paragraph");
var Serialise_1 = require("Project/QwilrEditor/Tokenization/Serialise");
var createEmptyBox = function () { return ({
    children: [createEmptyBoxColumn(), createEmptyBoxColumn()],
    isVoid: false,
    type: "box",
    data: {},
}); };
var createEmptyBoxColumn = function () { return ({
    type: "boxColumn",
    children: [(0, Paragraph_1.createParagraphNode)()],
    isVoid: false,
}); };
exports.boxConfig = (0, MakeConfig_1.makeConfig)(__assign(__assign({}, (0, GetCommonConfigByType_1.getCommonConfigByType)("box")), { node: {}, nodeType: "layoutElement", editorRender: BoxWidget_1.BoxWidget, firstLastConfiguration: { isValidFirstChild: true }, width: "full-width", deserialise: function (token, content, commentTracker) {
        return {
            type: "box",
            children: token.columns.map(function (children) { return ({
                children: (0, Deserialise_1.deserialiseNode)(children, commentTracker).children,
                type: "boxColumn",
                isVoid: false,
            }); }),
            isVoid: false,
            data: {},
        };
    }, serialise: function (node, editor, commentTracker, selection) {
        var children = node.children;
        return [
            {
                type: "block",
                subType: "box",
                columns: [
                    (0, Serialise_1.serialiseElements)(children[0].children, editor, commentTracker, selection),
                    (0, Serialise_1.serialiseElements)(children[1].children, editor, commentTracker, selection),
                ],
            },
        ];
    }, onAddWidget: function (_a) {
        var editor = _a.editor;
        var widget = createEmptyBox();
        var currentSelection = editor.selection;
        if (!slate_1.Range.isRange(currentSelection)) {
            return;
        }
        var currBlockEntry = (0, Utils_1.getClosestBlock)(editor, slate_1.Range.start(currentSelection).path);
        if (!currBlockEntry) {
            return;
        }
        slate_1.Editor.withoutNormalizing(editor, function () {
            slate_1.Transforms.removeNodes(editor, { at: currBlockEntry[1] });
            slate_1.Transforms.insertNodes(editor, widget, { at: currBlockEntry[1] });
        });
    }, validContainers: ["sideBySideColumn", "accordionBody", "contentLoopBody", "boxColumn"], validEditors: ["standard"], normalizeWidget: function (node, path, editor) {
        for (var i = 0; i < node.children.length; i++) {
            var currChild = node.children[i];
            if (Text.isText(currChild) || currChild.type !== "boxColumn") {
                slate_1.Transforms.delete(editor, { at: __spreadArray(__spreadArray([], __read(path), false), [i], false) });
                return true;
            }
        }
        if (node.children.length < 2) {
            slate_1.Transforms.insertNodes(editor, createEmptyBoxColumn(), { at: __spreadArray(__spreadArray([], __read(path), false), [0], false) });
            return true;
        }
        return false;
    }, widgetAdderConfig: {
        icon: react_1.default.createElement(icons_1.LinkedinBox, null),
        tags: ["box", "2col", "layout"],
        displayName: "box",
        requiresFeatures: [FeatureFlag_1.default.EditorRegistryWidgets],
    }, contentAddedType: TelemetryParameterValue_1.ContentAddedType.Box, containerNodeConfiguration: {
        showWidgetAdder: false,
    } }));
